<template>
    <EmbedVideoLightbox
        @close="store.closeLightbox()"
        v-if="lightbox.open"
        :url="lightbox.embedUrl"
    />
</template>

<script>
import EmbedVideoLightbox from "@/components/common/lightbox/EmbedVideoLightbox.vue";
import { useAppStore } from "@/stores/app";
import { storeToRefs } from "pinia";
import { AppRoot } from "@/mixins/AppRoot";

export default {
    extends: AppRoot,
    setup() {
        const store = useAppStore();
        const { lightbox } = storeToRefs(store);

        return {
            store,
            lightbox,
        };
    },
    components: {
        EmbedVideoLightbox,
    },
};
</script>

<style scoped></style>
